import * as req from 'api/actions';
import * as c from './constants';

export const getListCms = (payload = { sort_by: 'desc' }, callback) =>
  req.list('CMS/get_settings', '/api/v1/taxpayers/cms', payload, callback);

export const getPaperList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    'CMS/get_paper_settings',
    '/api/v1/administrators/cms',
    payload,
    callback
  );

export const getFeeOptionList = (transactionId, payload, callback) =>
  req.list(
    c.GET_FEE_OPTIONS,
    `/api/v1/administrators/transaction_histories/${transactionId}/fees`,
    payload,
    callback
  );

export const findPayment = (payload, callback) =>
  req.findPost(
    c.FIND_PAYMENT,
    '/api/v1/administrators/payments/inquiry',
    payload,
    callback
  );

export const tagAsForPosting = (payload, callback) =>
  req.findPost(
    c.TAG_FOR_POSTING,
    '/api/v1/administrators/payments/rollback',
    payload,
    callback
  );

export const viewPaymentLogs = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS,
    '/api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const viewPaymentLogsForTxn = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS_FOR_TXNID,
    '/api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const changeTxn = (payload, callback) =>
  req.findPost(
    c.UPDATE_TXN,
    '/api/v1/administrators/payments/transaction_histories',
    payload,
    callback
  );

export const postPaymentToQpax = (payload, callback) =>
  req.findPost(
    c.POST_PAYMENT_TO_QPAX,
    '/api/v1/administrators/payments/post_to_qpax',
    payload,
    callback
  );

export const manualExpireRefno = (payload, callback) =>
  req.findPost(
    c.MANUAL_EXPIRE_REFNO,
    '/api/v1/administrators/payments/expire',
    payload,
    callback
  );

export const approveRefund = (payload, callback) =>
  req.findPost(
    c.APPROVE_REFUND,
    '/api/v1/administrators/payments/refund_gcash_payment',
    payload,
    callback
  );

export const viewPaymentLogsForAmount = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS_FOR_AMOUNT,
    '/api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const changeAmount = (payload, callback) =>
  req.findPost(
    c.UPDATE_AMOUNT,
    '/api/v1/administrators/payments/update_amount',
    payload,
    callback
  );

export const changeYear = (payload, callback) =>
  req.findPost(
    c.CHANGE_YEAR,
    '/api/v1/administrators/payments/update_year',
    payload,
    callback
  );

export const changeQuarter = (payload, callback) =>
  req.findPost(
    c.UPDATE_QUARTER,
    '/api/v1/administrators/payments/update_period',
    payload,
    callback
  );

export const manualPaymentApprove = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/approve`,
    payload,
    callback
  );

export const manualPaymentReject = (id, payload, callback) =>
  req.update(
    c.MANUAL_PAYMENT_APPROVE,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment/reject`,
    payload,
    callback
  );

export const changeReferenceNumber = (payload, callback) =>
  req.findPost(
    c.UPDATE_REFERENCE_NUMBER,
    '/api/v1/administrators/payments/update_reference_number',
    payload,
    callback
  );

export const postEgovPay = (payload, callback) =>
  req.findPost(
    c.POST_EGOV_PAY,
    '/api/v1/administrators/payments/egovpay_post_payment',
    payload,
    callback
  );

export const getOfficialReceipts = (payload, callback) =>
  req.list(
    c.GET_OFFICIAL_RECEIPTS,
    `/api/v1/administrators/transaction_histories/${localStorage.getItem(
      'transId'
    )}/official_receipts`,
    payload,
    callback
  );

export const showOfficialReceipt = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_OFFICIAL_RECEIPT,
    `/api/v1/administrators/transaction_histories/${localStorage.getItem(
      'transId'
    )}/official_receipts/${id}`,
    payload,
    callback
  );

export const createOfficialReceipt = (payload, callback) =>
  req.create(
    c.CREATE_OFFICIAL_RECEIPT,
    `/api/v1/administrators/transaction_histories/${localStorage.getItem(
      'transId'
    )}/official_receipts`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateOfficialReceipt = (id, payload, callback) =>
  req.update(
    c.UPDATE_OFFICIAL_RECEIPT,
    `/api/v1/administrators/transaction_histories/${localStorage.getItem(
      'transId'
    )}/official_receipts/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeOfficialReceipt = (id, payload, callback) =>
  req.remove(
    c.REMOVE_OFFICIAL_RECEIPT,
    `/api/v1/administrators/transaction_histories/${localStorage.getItem(
      'transId'
    )}/official_receipts/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const finalizeOfficialReceipt = (id, payload, callback) =>
  req.update(
    c.FINALIZE_OFFICIAL_RECEIPT,
    `/api/v1/administrators/transaction_histories/official_receipts/${id}/finalize`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const manualPaymentPosting = (id, payload, callback) =>
  req.create(
    c.MANUAL_PAYMENT_POSTING,
    `/api/v1/administrators/transaction_histories/${id}/check_payment_posting`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Posted !');
      if (callback) callback();
    }
  );

export const rollbackPayment = (payload, callback) =>
  req.findPost(
    c.ROLLBACK_PAYMENT,
    '/api/v1/administrators/payments/rollback_payment',
    payload,
    callback
  );

export const getFindPaymentList = (payload, callback) =>
  req.list(
    c.GET_FIND_PAYMENT_LIST,
    '/api/v1/administrators/payments/transaction_histories',
    payload,
    callback
  );

export const findPaymentById = (id, callback) =>
  req.item(
    c.FIND_PAYMENT_BY_ID,
    `/api/v1/administrators/payments/transaction_histories/${id}`,
    callback,
  );